import { Button, EmptyState } from "@station/ui";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import { Compass, TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { errorMessage } from "../lib/errors.js";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Outlet,
  notFoundComponent: NotFound,
  errorComponent: RootError,
});

function NotFound() {
  const { t } = useTranslation();
  return (
    <main className="mx-auto max-w-lg p-8">
      <EmptyState
        icon={<Compass />}
        title={t("errors.notFound.title")}
        description={t("errors.notFound.description")}
        action={
          <Button asChild>
            <Link to="/">{t("errors.notFound.action")}</Link>
          </Button>
        }
      />
    </main>
  );
}

function RootError({ error, reset }: { error: unknown; reset: () => void }) {
  const { t } = useTranslation();
  return (
    <main className="mx-auto max-w-lg p-8">
      <EmptyState
        icon={<TriangleAlert />}
        title={t("errors.unexpected.title")}
        description={errorMessage(error)}
        action={<Button onClick={reset}>{t("common.retry")}</Button>}
      />
    </main>
  );
}
